export default __webpack_public_path__ + "static/media/spacemens-smd.59c75124.png";